export default {"src":"/_next/static/media/sailing-together-lg.mono.9d2294fa.svg","height":374,"width":524,"blurWidth":0,"blurHeight":0};